// src/firebase.js
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import {getFirestore} from "firebase/firestore";
import {getStorage} from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDynJ_BZ5fodzgPHDz9cX2E0ItfLD6aoNc",
  authDomain: "medical-marketplace-fdd95.firebaseapp.com",
  databaseURL:
    "https://medical-marketplace-fdd95-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "medical-marketplace-fdd95",
  storageBucket: "medical-marketplace-fdd95.firebasestorage.app",
  messagingSenderId: "279243048794",
  appId: "1:279243048794:web:86c830c24314ba52f61563",
  measurementId: "G-PVJZP5600Z",
};

export const app = initializeApp(firebaseConfig);

// Analytics can throw if not in a browser/https; wrap just in case.
try {
  if (typeof window !== "undefined") getAnalytics(app);
} catch (e) {
  // ignore analytics errors in dev/non-https
}

export const auth = getAuth(app);
// Remember across browser restarts
setPersistence(auth, browserLocalPersistence);

export const db = getFirestore(app);
export const storage = getStorage(app);

// Optional default export so `import app from "./firebase"` works:
export default app;
